<div class="tag">
    <div class="delete-tag mx-3 mx-md-4 my-3 my-md-4">
        <div class="row">
            <div class="col-12 text-center">
                <p class="ft-16 my-4 my-md-2 col-707070">Delete this tag?</p>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <button class="btn btn-light ft-14 px-4 mb-2 mt-2  cancel-tag me-3" (click)="closeModel()">Cancel</button>
                <button class="btn btn-primary ft-14 px-4 mb-2 mt-2 delete-tag-btn" (click)="getDeleteTag()" >Delete</button>
            </div>
        </div>
    </div>
</div>

<ngx-loading [show]="loading">Loading...</ngx-loading>